import React, {useMemo, useRef, useState} from 'react';
import {Card, Checkbox, InputNumber, Statistic} from "antd";
import Form, {FormInputComponent} from "../../../components/form/Form";
import {useOpportunity} from "../../../providers/OpportunityProvider";

const TalentFixedFeePayoutEditTab = ({
                                         opportunity,
                               }) => {
    const {
        isDisabled,
        onUpdate,
    } = useOpportunity();
    const [isCollapseActive, setIsCollapseActive] = useState(true);


    let talentOpp = TB.cloneDeep(opportunity.job_candidate.talent_opps[0]);
    const editable = opportunity.canEditProposal();

    const [formModel, setFormModel] = useState(TB.pick({
        ...talentOpp
    }, [
        'total_hours',
        'hourly_rate',
        'position_deliverables',
        'has_accepted_proposed_payout',
    ]));


    const proposedPayout = useMemo(() => {
        const hours = parseInt(TB.sumBy(formModel.position_deliverables, 'total_hours'));
        const rate = parseFloat(formModel.hourly_rate);

        if (TB.isNaN(hours) || TB.isNaN(rate)) {
            return 0;
        }

        return Math.ceil(hours * rate);
    }, [
        formModel?.total_hours,
        formModel?.hourly_rate,
            ...TB.map(formModel.position_deliverables || [], 'total_hours'),
        formModel.has_accepted_proposed_payout
    ])

    const hasFormModelChanged = useMemo(() => {
        if (formModel.has_accepted_proposed_payout !== talentOpp.has_accepted_proposed_payout
            || formModel.hourly_rate !== talentOpp.hourly_rate
        ) {
            return true
        }
        let hasFormChange = false;
        TB.map(formModel.position_deliverables, del => {
            let matchedDel = TB.find(talentOpp.position_deliverables, ['id', del.id]);
            if (matchedDel && matchedDel.total_hours !== del.total_hours) {
                hasFormChange = true;
            }
        })
        return hasFormChange;
    }, [
        formModel?.total_hours,
        formModel?.hourly_rate,
        ...TB.map(formModel.position_deliverables || [], 'total_hours'),
        formModel.has_accepted_proposed_payout
    ])

    const mapping = (model = {}) => {

        return model;
    }

    const formRef = useRef(null);



    // console.log('TeamMemberPayoutEditTab', hadDifferentPayout)

    // console.log('Success: opportunity', opportunity)

    const resetForm = async () => {

        // await setFormModel({disciplines: [...mappedDisciplines]});
        return formRef.current?.forceReset(talentOpp)
    }

    const submitForm = async () => {
        let invalid = formRef.current.forceValidate(formModel);
        if (invalid) {
            console.log('invalid', invalid)
            return;
        }
        let totalHours = formModel.total_hours;
        if (formModel.has_accepted_proposed_payout) {
            totalHours = TB.sumBy(formModel.position_deliverables, 'total_hours')
        }
        let success = await onUpdate({job_candidate: {...formModel, total_hours: totalHours}, talent_proposed_at: opportunity.talent_proposed_at || new Date()}, opportunity)

        if (success) {
            await resetForm();
        }
    }
    return (
        <React.Fragment>


            <div className="opp-talent-proposal-form pr-4">
                <div className="lg:flex flex-row items-center my-2">
                    <h3 className="proposal-tab-header mr-2 mb-0 mt-0">
                        Payout & Estimated Hours
                    </h3>
                    <p className="proposal-tab-subheader mb-0 mt-0">
                        Confirm the talent's bill rate and estimated payout to work on the project
                    </p>
                </div>
                <Form
                    ref={formRef}
                    background={"transparent"}
                    // mapping={mapping}
                    minimal={true}
                    submitButton={false}
                    isDisabled={isDisabled}
                    onSubmit={submitForm}
                    model={formModel}
                    fields={[]}
                    // className={
                    //     TB.mapClass({
                    //         'no-edit': !editable
                    //     })
                    // }
                    onChange={async (model) => {

                        let updatedModel = {...formModel}
                        // console.log('onchange');
                        for (let [key, value] of Object.entries(model)) {
                            updatedModel = TB.set(updatedModel, key, value);
                        }

                        await setFormModel(updatedModel);
                    }}>
                    <div className="flex flex-col gap-3">

                        {/*<div className="lg:flex flex-col items-start my-2">*/}
                        {/*    <h3 className="proposal-tab-header whitespace-nowrap mr-2 mb-1 mt-0">*/}
                        {/*        Role:&nbsp;*/}
                        {/*        <span className="text-primary">{opportunity.project_position?.name}</span>*/}
                        {/*    </h3>*/}
                        {/*    /!*{opportunity.project_position && (*!/*/}
                        {/*    /!*    <div className="rich-text-display">*!/*/}
                        {/*    /!*        <span dangerouslySetInnerHTML={{__html: opportunity.project_position.description}}*!/*/}
                        {/*    /!*        />*!/*/}
                        {/*    /!*    </div>*!/*/}
                        {/*    /!*)}*!/*/}
                        {/*</div>*/}

                        <div className="px-4 py-3 border border-[#913ef0] mt-3">
                            <div className="flex flex-row-reverse justify-between items-start">

                                <div
                                    className="flex flex-row flex-nowrap items-center justify-center gap-2.5 min-w-[20%]">
                                    {/*{parseInt(proposedPayout) !== parseInt(estimatedPayout) && (*/}
                                    {/*    <Statistic title="Estimated Payout" value={TB.formatNumber(estimatedPayout, 2)}*/}
                                    {/*               formatter={value => (*/}
                                    {/*                   <span className="line-through text-danger">*/}
                                    {/*                       {TB.formatCurrency(value, false)}*/}
                                    {/*                   </span>*/}
                                    {/*               )}/>*/}
                                    {/*)}*/}

                                    <Card bordered={false} className="bg-gray-100" size="small">
                                        <Statistic
                                            title={
                                                parseInt(proposedPayout) === parseInt(opportunity.project_position?.estimated_payout) ? 'Estimated Payout' :
                                                    <span className="opacity-60 text-danger whitespace-no-wrap">Proposed Payout</span>}
                                            value={TB.formatNumber(proposedPayout, 2)}
                                            formatter={value => TB.formatCurrency(value, false)}/>
                                    </Card>
                                </div>


                                <div className="flex-grow">


                                    <div className="flex flex-col gap-3 mt-3" key={`editing-dis-${opportunity.id}`}>

                                        <div className="field-section">
                                            <div className="field flex flex-row items-center self-start">
                                                <Checkbox checked={formModel.has_accepted_proposed_payout} onChange={async (e) => {
                                                    let formUpdates = {};

                                                    await setFormModel({...formModel, has_accepted_proposed_payout: e.target.checked});

                                                    formUpdates.hourly_rate = e.target.checked ? opportunity.job_candidate?.original_rate : talentOpp.hourly_rate;

                                                    TB.map([...talentOpp.position_deliverables], (del, delIndex) => {
                                                        let matchedDel = TB.find(opportunity.project_position.deliverables, ['id', del.id]);
                                                        if (matchedDel) {
                                                            formUpdates[`position_deliverables[${delIndex}].total_hours`] = e.target.checked ? matchedDel?.total_hours : del.total_hours;
                                                        }
                                                        return del;
                                                    })


                                                    if (Object.keys(formUpdates).length) {
                                                        return formRef.current?.updateInputsWithValue(formUpdates)
                                                    }
                                                }}>
                                                    By checking this box, I accept an hourly rate
                                                    of <b>${TB.formatNumber(opportunity.job_candidate.original_rate, 0)}/hr</b> for a total
                                                    of <b>{TB.sumBy(opportunity.project_position.deliverables, 'total_hours')} hours.</b>
                                                </Checkbox>
                                            </div>
                                        </div>

                                        <div
                                            className="sm:flex md:block min-[880px]:flex flex-row items-start justify-start gap-4">

                                            <label className="col-form-label">
                                                Proposed Hourly Rate:
                                            </label>
                                            <FormInputComponent
                                                type="antd-input"
                                                label={false}
                                                className="sm:w-1/2 md:w-full min-[880px]:w-1/2 lg:w-1/3"
                                                fieldName={`hourly_rate`}
                                                disabled={formModel.has_accepted_proposed_payout || isDisabled}
                                                value={formModel.hourly_rate}
                                                required={!formModel.has_accepted_proposed_payout}
                                                min={1}
                                            >

                                                <InputNumber
                                                    precision={0}
                                                    controls={false}
                                                    addonBefore="$"
                                                    addonAfter=" per hour "
                                                    step={1}
                                                    defaultValue={Number.parseInt(formModel.hourly_rate).toFixed(0)}
                                                />

                                            </FormInputComponent>
                                        </div>
                                        {/*<div*/}
                                        {/*    className="sm:flex md:block min-[880px]:flex flex-row items-start justify-start gap-4">*/}
                                        {/*    <label className="col-form-label">*/}
                                        {/*        Proposed Total Hours:*/}
                                        {/*    </label>*/}
                                        {/*    <FormInputComponent*/}
                                        {/*        type="antd-input"*/}
                                        {/*        label={false}*/}
                                        {/*        className="sm:w-1/2 md:w-full min-[880px]:w-1/2 lg:w-1/3"*/}
                                        {/*        fieldName={`proposed_total_periods`}*/}
                                        {/*        disabled={formModel.has_accepted_proposed_payout || isDisabled}*/}
                                        {/*        value={formModel.proposed_total_periods}*/}
                                        {/*        required={!formModel.has_accepted_proposed_payout}*/}
                                        {/*        min={1}*/}
                                        {/*        validation={{*/}
                                        {/*            rules: {*/}
                                        {/*                isInt: true,*/}
                                        {/*            }*/}
                                        {/*        }}*/}
                                        {/*    >*/}

                                        {/*        <InputNumber*/}
                                        {/*            min={1}*/}
                                        {/*            controls={false}*/}
                                        {/*            addonAfter={<span className="text-[13px]">hours</span>}*/}
                                        {/*            defaultValue={formModel.total_hours}*/}
                                        {/*        />*/}

                                        {/*    </FormInputComponent>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col items-stretch divide-y divide-gray-200">
                            {TB.map(formModel.position_deliverables, (deliverable, delIndex) => {


                                return (
                                    <div className="flex flex-row items-start py-1.5 gap-4"
                                         key={`del-${deliverable.id}`}>
                                        <div className="flex flex-col gap-1 items-start flex-grow">
                                            <p className="font-medium text-sm">
                                                {deliverable.name}
                                            </p>
                                            <p className="text-info text-xs">
                                                {deliverable.description}
                                            </p>
                                        </div>


                                        <div className="flex flex-row items-start justify-end max-w-[130px] min-w-[130px]">
                                            <FormInputComponent
                                                type="antd-input"
                                                label={false}
                                                className="w-full"
                                                fieldName={`position_deliverables[${delIndex}].total_hours`}
                                                disabled={formModel.has_accepted_proposed_payout || isDisabled}
                                                value={deliverable.total_hours}
                                                required={!formModel.has_accepted_proposed_payout}
                                                min={1}
                                            >

                                                <InputNumber
                                                    precision={0}
                                                    controls={false}
                                                    addonAfter=" hours"
                                                    step={1}
                                                    defaultValue={deliverable.total_hours}
                                                />

                                            </FormInputComponent>
                                        </div>

                                    </div>
                                )
                            })}

                            <div className="flex flex-row items-center justify-between py-2">
                                <p className="font-semibold flex-1 text-sm">

                                </p>
                                <p className="font-semibold flex-1 text-xs text-right">
                                    Total: {TB.sumBy(formModel.position_deliverables, 'total_hours')} hours
                                </p>
                            </div>
                        </div>

                        {/*<Collapse className="mt-5" ghost activeKey={isCollapseActive}*/}
                        {/*          onChange={key => setIsCollapseActive(TB.first(key || []))}>*/}
                        {/*    <Collapse.Panel key="deliverables" showArrow={false} header={(*/}
                        {/*        <div className="flex flex-col items-center">*/}
                        {/*            <p className="text-gray-400 flex flex-row items-center gap-2">*/}
                        {/*                <i className={TB.mapClass("transition-all fas text-xs", {*/}
                        {/*                    "fa-angle-double-down": true,//!isCollapseActive,*/}
                        {/*                    // "fa-angle-double-up": isCollapseActive,*/}
                        {/*                    "rotate-180": isCollapseActive,*/}
                        {/*                    "rotate-0": !isCollapseActive,*/}
                        {/*                })}/>*/}
                        {/*                <span>*/}
                        {/*                    {isCollapseActive ? 'Hide' : 'View'} estimated hours by deliverable*/}
                        {/*                </span>*/}
                        {/*                <i className={TB.mapClass("transition-all fas text-xs", {*/}
                        {/*                    "fa-angle-double-down": true,//!isCollapseActive,*/}
                        {/*                    // "fa-angle-double-up": isCollapseActive,*/}
                        {/*                    "rotate-180": isCollapseActive,*/}
                        {/*                    "rotate-0": !isCollapseActive,*/}
                        {/*                })}/>*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*    )}>*/}
                        {/*        */}
                        {/*    </Collapse.Panel>*/}
                        {/*</Collapse>*/}
                    </div>
                    {editable && (
                        <div className="mt-3 flex flex-row justify-end">
                            <button type="submit" className="btn btn-primary mr-3"
                                    disabled={isDisabled || !hasFormModelChanged}>
                                Save
                            </button>
                            <button className="btn btn-outline-dark"
                                    type="button" onClick={resetForm}
                                    disabled={isDisabled || !hasFormModelChanged}>
                                Cancel
                            </button>
                        </div>
                    )}
                </Form>
            </div>
        </React.Fragment>
    )
};

export default TalentFixedFeePayoutEditTab;